import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
import styles from './style.module.css';
import axios from 'axios';
import { ScrollMenu, InputDropdown } from '../../elements';
import {
    allSites,
    siteRegions,
    siteSubholdings,
    siteSubsidiaries,
    siteData,
    subsidiaryData,
    subholdingData,
    regionData,
} from '../../../configs';

// for Menu needs
/*
  Site Documentations
*/
export default function SiteList(props) {
    const { selects, onSelected } = props;
    // const [ filter, setFilter ] = useState({ region: '', subsidiary: '', subholding: '' });
    const [siteList, setSiteList] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [subsidiaryList, setSubsidiaryList] = useState(subsidiaryData);
    const [subholdingList, setSubholdingList] = useState(subholdingData);
    const [regionList, setRegionList] = useState(regionData);

    const loadInitalSites = async (cancelTokenSite) => {
        try {
            const responseSites = await axios.get(allSites, {
                cancelToken: cancelTokenSite,
            });

            // response for category
            if (responseSites.status === 200) {
                setSiteList(responseSites.data);
                setFilteredList(responseSites.data);
            }
        } catch (error) {
            if (axios.isCancel(error)) {
                console.log('fetch initial question/answer count aborted.');
            } else {
                console.log(error.message);
                console.log(error.res);
                // setLoading(false);
            }
        }
    };

    useEffect(() => {
        // --for dummy--
        // setInputList(inputList1);
        const sourceSite = axios.CancelToken.source();
        // const sourceAnswer = axios.CancelToken.source();

        loadInitalSites(sourceSite.token);

        // count total answer
        // countAnswerInStorage();

        return () => {
            /* TODO document why this arrow function is empty */
        };
    }, []);

    useEffect(() => {
        // --for dummy--
        // setInputList(inputList1);
        let filteredData = siteList;
        if (siteList !== []) {
            if (selects.region !== '') {
                filteredData = filteredData.filter((site) => {
                    return +site.region_id === +selects.region;
                })
            }
            if (selects.subholding !== '') {
                filteredData = filteredData.filter((site) => {
                    return +site.subholding_id === +selects.subholding;
                })
            }
            if (selects.subsidiary !== '') {
                filteredData = filteredData.filter((site) => {
                    return +site.subsidiary_id === +selects.subsidiary;
                })
            }

            setFilteredList(filteredData)
        }

        return () => {
            /* TODO document why this arrow function is empty */
        };
    }, [selects, siteList]);

    return (
        <div className={styles.root}>
            <select
                id="filter-subsidiary"
                value={selects.subsidiary}
                onChange={onSelected}
            >
                <option disabled value="">
                    Filter Subsidiary
                </option>
                {subsidiaryList.map((item, index) => (
                    <option
                        key={`filter-subsidiary-${index}`}
                        value={`${item.subsidiaryId}`}
                    >
                        {item.subsidiaryName}
                    </option>
                ))}
            </select>
            <select
                id="filter-subholding"
                value={selects.subholding}
                onChange={onSelected}
            >
                <option disabled value="">
                    Filter Subholding
                </option>
                {subholdingList.map((item, index) => (
                    <option
                        key={`filter-subholding-${index}`}
                        value={`${item.subholdingId}`}
                    >
                        {item.subholdingName}
                    </option>
                ))}
            </select>
            <select id="filter-region" value={selects.region} onChange={onSelected}>
                <option disabled value="">
                    Filter Region
                </option>
                {regionList.map((item, index) => (
                    <option key={`filter-region-${index}`} value={`${item.regionId}`}>
                        {item.regionName}
                    </option>
                ))}
            </select>
            {/* <InputDropdown
                className={styles.addSourceWaterInput}
                name={`addWaterInput`}
                label={'Subsidiary'}
                // defaultValue={defaultValue}
                options={subsidiaryList}
                required={true}
            /> */}
            <ScrollMenu data={filteredList} />
        </div>
    );
}
